export const REVIEWS_LABEL = "Reviews"
export const DYNAMIC_SEARCH_LABEL = "dynamic search"
export const MISSING_IMAGE_KEY = "MissingImage"
export const FRIENDS_AND_FAMILY_PROGRAM = "friends and family program"
export const KOHLER_FRIENDS_AND_FAMILY_MEMBERSHIP =
  "kohler friends and family membership"

export const HERO_BANNER = "hero banner"
export const GENERIC_ERROR_MESSAGE = "Something went wrong. Please try again..."

export const MORE_OPTIONS = {
  LEARN_MORE: "Learn More",
  EXPLORE_MORE: "Explore More",
  FREE_QUOTE: "Get a FREE Quote",
  FIND_PRO: "Find a Pro",
  INSTALLATION_SERVICES: "Buy Now",
  WATCH_VIDEO: "Watch Video",
}

export const ORDER_STATUS = {
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
  CREDIT_CARD: "CREDIT_CARD",
  PAYPAL: "PP",
  ACI_PAYPAL: "Paypal",
  SHIPPED: "Shipped",
}

export const FRAGMENT_TYPES = {
  HEADER: "header",
  MAIN: "main",
  FOOTER: "footer",
}

export const ORDER_THANKYOU = "order:thank you"
export const ORDER_CONFIRMATION = "order confirmation"

export const PriceRangeFrench = "Fourchette de prix"
export const PRICE_RANGE_FRENCH = PriceRangeFrench
export const LOCALE_ENGLISH = "en-US"
export const LOCALE_CANADA_FR = "fr-CA"

export const PRICE_RANGE = "Price_Range"
export const PDP_FIND_ON_DISPLAY = "pdp:find on display"
export const PRICE_RANGE_FRENCH_LOCALE = "priceList.ANY.finalPrice_d"
export const DISCOUNTED_PRICE_FACET_LABEL = "discountedPriceStartingAt"

export const PDP_TYPE = "regular w/ required items"
export const PDP_FEEDBACK = "pdp:provide feedback"
export const SHOP_TOILET_SEATS = "shop toilet seats"
export const ORDER_STATUS_PAGE = "order status"
export const LITERATURE = "literature"
export const TECHNICAL_SPECIFICATIONS = "technical specs"
export const HOW_TO_BECOME_A_KPN = "how to become a kohler partner"
export const TWO_WAYS_TO_BE_A_KPN = "two ways to be a kohler partner"
export const JOIN_NOW = "Join Now"

export const SEARCH_INTERNAL_TYPE = {
  sterlingResults: "view sterling results",
  compare: "compare",
  partsDiagram: "parts diagram",
  serviceParts: "service parts",
}
export const INSTALL_ITEMS = "items required for install test"
export const INSTALL_ITEMS_EDIT = "edit items required for install"
export const MY_ACCOUNT_MODAL = "my account modal section"
export const CREATE_ACCOUNT = "create account"
export const BRAND_NAME = {
  annSacks: "Ann Sacks",
  sterling: "STERLING",
  homeEnergy: "Home Energy",
}
export const BROWSE_ALL_KOHLER_STORES = "browse all kohler stores"
export const BROWSE_ALL_KOHLER_STORES_FR = "parcourir tous les magasins kohler"
export const FIND_A_STORE = "find a store"
export const FIND_A_STORE_FR = "trouver un magasin"
export const PDP_DETAILS = "pdp:product details"
export const PDP_FAVORITE = "favorites"
export const PDP_GUEST_FAVORITE = "guest favorites"
export const NAVIGATION_TYPE = {
  PRODUCT: "product navigation",
  MEGA_MENU: "mega menu navigation",
  GLOBAL: "global navigation",
}
export const CHECKOUT_PAYMENT = "payment & billing"

export const PDP_TYPES = "regular finished goods"
export const STOCKS = {
  OUT_OF_STOCK: "out of stock",
  IN_STOCK: "in stock",
}
export const PERCENT_OFF = "percentOff|"
export const REGULAR_PRICE = "regular price"
export const CONTACT_US_SUPPORT = "support:contact:form"
export const CONTACT_US_FORM = "support:contact"
export const HELP_AND_SUPPORT = "help and support"
export const HELP_SUPPORT = "help support"
export const CALL_OUR_TEAM = "call our team"

export const PRESS_KIT_PAGE_TYPE = "press-kit"
export const BUYING_GUIDE = "Buying Guide"
export const SHOP_THE_LOOK = "shop the look"
export const INTERACTIVE_TAGS = ["A", "BUTTON", "INPUT", "TEXTAREA", "SELECT"]
export const SERVICES = [
  "Install Services",
  "Design Services",
  "INSTALL SERVICES",
  "DESIGN SERVICES",
]

export const PRODUCT_EXCLUDE_FROM_PAID_ADVERTISING =
  "ProductExcludeFromPaidAdvertising"
export const VALID_SPACER_SIZES = new Set(["none", "xs", "s", "m", "l", "xl"])
export const SPACER_ALIAS = {
  "top size": "none",
  "bottom size": "none",
  small: "s",
  medium: "m",
  large: "l",
}

export const BUNDLE_LABEL = "BUNDLE"
export const GIFT_DESIGN = "give the gift of design"
export const KOHLER_BATHROOM_DESIGN = "kohler bathroom design"

export const QUICK_VIEW = "quick view"
export const CLOSE = "close"
export const QUICK_VIEW_MODAL = "quick view modal"
export const PRODUCT = "product"
export const COLOR = "color"
export const IMG_ITEM_ISO = "imgitemiso"
export const ADD_TO_CART = "add to cart"
export const VIEW_FULL_DETAILS = "view full details"
export const CAROUSEL_IMAGE = "carousel image"
export const NOTIFY = "notify me"
export const PROMO_TILES = "promo tiles"
export const NO_ACTIVE_CART_EXISTS = "No active cart exists."
export const STERLING_LINK = [
  {
    brandName: "STERLING",
    link: "https://sterling.kohler.com",
    linkRef: true,
  },
]
export const GRADIENT_DICTIONARY = {
  topToBottom: "top-bottom",
  bottomToTop: "bottom-top",
  leftToRight: "left-right",
  rightToLeft: "right-left",
  radialCenterOut: "tint",
}
export const PROMO_COLUMNS = {
  "one-column": "1-column",
  "two-column": "2-column",
  "three-column": "3-column",
}

// Backward compatible aliases.
export const reviews = REVIEWS_LABEL
export const dynamicSearch = DYNAMIC_SEARCH_LABEL
export const missingImage = MISSING_IMAGE_KEY
export const orderConstants = ORDER_STATUS
